import React, { useEffect } from "react";
export default function About() {
    useEffect(() => {
        document.title = "About";
    }, []);

    return (
        <>
            <div className="container">
                <div className="body row">
                    <div className="staff">
                        <div className="col-md-2">
                            <img src="img/headshot.jpg" alt="head shot" />
                        </div>
                        <div className="bio col-md-10">
                            <h2>Laura Mills</h2>
                            <h4>Consultant</h4>
                            <p>I am a past editor of the Chambers USA Guide and its longest-serving editor. During my tenure overseeing the guide, the level of participation increased by 30%, reaching just under 11,000 submissions, thanks in part to my drive to improve transparency in the research process and my desire to help firms improve their submissions.</p>
                            <p>I now take my extensive knowledge of the guides and the legal market, and the experience I gained sharing best practice insights, to work more closely with firms to improve their performance in and understanding of directories like Chambers and Legal 500.</p>
                            <p>In the nine years since founding LC Mills Consulting, I have been fortunate to work with nearly 100 firms of all sizes in jurisdictions around the world, helping to improve their submissions and performance in the rankings.</p>
                            <p>While the bulk of my time has focused on the USA, I have worked across the whole family of Chambers Guides, covering major centers of economic and legal activity around the world. I am familiar with all areas of business law covered in the directories, so will waste no time in understanding your firm's work.</p>
                            <p>I am a dual US/UK citizen, and after 17 years of living in London, my family and I relocated to my hometown of Buffalo, NY in 2023. I have a BA in History and Middle Eastern Studies from the University of Pittsburgh and an MA in Middle Eastern Studies from the School of Oriental and African Studies – University of London. COYG and Go Bills.</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
